import styled from 'styled-components';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import TextareaAutosize from 'react-autosize-textarea';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Field = styled(TextareaAutosize)`
  color: #4D5473;
  background: #fff;
  padding: 0%;
  border: 0;
  width: 100%;
  resize: none;
  overflow-y: scroll;
  :focus {
    border: 0;
  }
  :before {
    content: "...";
    font: "Roboto";
    font-size: 23pt;
    color: #5E6C84;
    float: right;
  }
`;

const Container = styled.div``;

const Icon = styled(SemanticIcon)`
  cursor: pointer;
`;

const Text = styled(TextLayoutComponent)`
  word-wrap: break-word;
`;

const EditButton = styled.a`
  user-select: none;
`;

export {
  Field,
  Container,
  Icon,
  Text,
  EditButton,
};
